const HasHeaderPermission = (moduleName, permissionType) => {
  const userPermissions = JSON.parse(localStorage.getItem("userPermissions")) || []
  if (userPermissions.length < 1) return true;
  const module = userPermissions.find(
    (m) => m.moduleName.toLowerCase() === moduleName.toLowerCase() && m.isMainModule == "1" && m.status === "1"
  );

  if (!module) return false;
  return module[permissionType] === "1";
};

export { HasHeaderPermission };
